import { render, staticRenderFns } from "./FlowCard.vue?vue&type=template&id=152c7028&scoped=true&"
import script from "./FlowCard.vue?vue&type=script&lang=js&"
export * from "./FlowCard.vue?vue&type=script&lang=js&"
import style0 from "./FlowCard.vue?vue&type=style&index=0&id=152c7028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c7028",
  null
  
)

export default component.exports